<template>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-12 col-sm-6 order-sm-last text-sm-right">
                <Button type="button" name="button" class="my-2" @click.prevent="volver()" icon="fas fa-arrow-left">Atrás</Button>
            </div>
            <div class="col-12 col-sm-6">
                <h1 class="my-2 text-dark">{{ title }}</h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String
    },
    data() {
        return {

        }
    },
    methods: {
        volver() {
            this.$router.go(-1);
        }
    }
}
</script>
